export const config = {
  title: "Renee Brown | Premier Real Estate Services in Houston, TX",
  meta: {
    description:
      "Renee Brown offers exceptional real estate services in Houston, TX, specializing in buying and selling homes with a deep understanding of local communities and market conditions.",
    keywords: [
      'Real Estate Houston',
      'Homes for Sale',
      'Property Listings',
      'Renee Brown Realtor',
      'Buying a Home',
      'Selling a Home',
      'Houston Real Estate Agent',
      'Champions NextGen Realty',
      'Texas Real Estate',
      'Residential Properties',
      'MyBizSolutions LLC',
      'BizSolutions LLC'
    ],
    author: "Renee Brown | Champions NextGen Realty",
    canonicalUrl: 'https://www.reneebrownsales.com/',
  },
  sections: {
    header: {
      businessName: "Renee Brown | Champions NextGen Realty",
    },
    sectionB: {
      heroTitle: "Renee Brown | Champions NextGen Realty",
      heroSubtitle: 'Exceeding Your Real Estate Expectations in Houston, TX',
      learnAboutText: 'Explore Our Listings',
      phoneNumber: '8323529590',
      phoneLabel: '(832) 352-9590',
      heroBackgroundImage:
        "https://www.spoliamag.com/wp-content/uploads/2021/07/pexels-curtis-adams-5178047-696x521.jpg",
      cardData: [
        {
          title: 'Mission',
          description:
            'To provide exceptional real estate services with a focus on client satisfaction, leveraging in-depth knowledge of Houston’s communities and market trends.',
        },
        {
          title: 'Vision',
          description:
            'To be recognized as a leading real estate professional in Houston, known for integrity, dedication, and outstanding results.',
        },
        {
          title: 'Why Choose Me',
          description:
            'With extensive experience and a commitment to personalized service, I guide clients through every step of the buying and selling process, ensuring informed decisions and successful transactions.',
        },
      ],
      description:
        "As a seasoned real estate agent with Champions NextGen, I offer comprehensive services to help you navigate Houston's dynamic real estate market. Whether you're buying or selling, I'm here to provide expert guidance and support.",
    },
    sectionC: {
      servicesTitle: 'My Services',
      servicesDescription:
        "Discover the range of real estate services I offer to meet your property needs.",
      cards: [
        {
          title: 'Buying a Home',
          description:
            "Assisting clients in finding and purchasing their dream homes in Houston's diverse neighborhoods.",
          imageSrc:
            'https://images.unsplash.com/photo-1570129477492-45c003edd2be', // Replace with an appropriate image URL
          imageAlt: 'Buying a Home'
        },
        {
          title: 'Selling a Home',
          description:
            "Providing strategic marketing and expert advice to sell your property at the best possible price.",
          imageSrc:
            'https://media.istockphoto.com/id/2148757444/photo/real-estate-agent-or-architect-showing-a-couple-a-new-home.jpg?s=612x612&w=0&k=20&c=iFhae087H1EBiXR2GSM4CQBVk_ETxeilo_XkgMlbGz8=',
          imageAlt: 'Selling a Home',
        },
        {
          title: 'Market Analysis',
          description:
            'Offering detailed market insights to help clients make informed real estate decisions.',
          imageSrc:
            'https://images.unsplash.com/photo-1580587771525-78b9dba3b914', // Replace with an appropriate image URL
          imageAlt: 'Market Analysis',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Property Valuations',
        'Home Staging Advice',
        'Negotiation Support',
        'Community Insights',
        'Investment Property Guidance',
      ],
    },
    sectionD: {
      aboutTitle: 'About Me',
      aboutImage: {
        src:
          'https://images.marketleader.com/MarketingImages/22/2404322_normal.jpg',
        alt: "Renee Brown",
      },
      aboutText: [
        "As an agent who knows this area inside and out, I bring a wealth of knowledge on local communities, current market conditions, and more. I strive to make your real estate experience an exceptional one.",
        "Whether buying or selling a home, I can advise you through the processes from beginning to close. Call me or email me to set up a time to discuss your specific real estate needs.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Renee Brown",
      businessName: "Renee Brown",
      contact: {
        phone: '8323529590',
        phoneLabel: '(832) 352-9590',
        email: 'trb2k24@gmail.com',
        website: 'https://www.reneebrownsales.com/',
        address: '738 TX-6 S, Houston, TX 77079',
      },
      socialMedia: {
        googlePlus: null,
        linkedIn: null,
        facebook: null,
        twitter: null,
        tiktok: null,
        instagram: null,
        youtube: null,
      },
    },
    sectionF: {
      address: '738 TX-6 S, Houston, TX 77079',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3444.123456789012!2d-95.1234567!3d29.1234567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c1234567890!2s738+TX-6+S,+Houston,+TX+77079!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus',
    },
  },
};

export default config;
